// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WeekDisplay2 {


    margin: 1em 0;

    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 1rem;

    .weekday-display {
        cursor: pointer;
        background-color: var(--accent-main-color);

        font-weight: 500;
        color: white;

        border-radius: 50%;
        align-content: center;
        aspect-ratio: 1;
        width: 3rem;
        height: 3rem;
        transition: all 300ms;
    }


    .weekday-display.selected-day {

        transform: scale(101%);
        color: var(--accent-secondary-color);
        border: 0.15em solid var(--accent-secondary-color);
        background-color: white;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/myAccount/WorkingHoursManagement/WeekDaySelector2.css"],"names":[],"mappings":"AAAA;;;IAGI,aAAa;;IAEb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;;IAEhB;QACI,eAAe;QACf,0CAA0C;;QAE1C,gBAAgB;QAChB,YAAY;;QAEZ,kBAAkB;QAClB,qBAAqB;QACrB,eAAe;QACf,WAAW;QACX,YAAY;QACZ,qBAAqB;IACzB;;;IAGA;;QAEI,sBAAsB;QACtB,oCAAoC;QACpC,kDAAkD;QAClD,uBAAuB;IAC3B;AACJ","sourcesContent":[".WeekDisplay2 {\n\n\n    margin: 1em 0;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    column-gap: 1rem;\n\n    .weekday-display {\n        cursor: pointer;\n        background-color: var(--accent-main-color);\n\n        font-weight: 500;\n        color: white;\n\n        border-radius: 50%;\n        align-content: center;\n        aspect-ratio: 1;\n        width: 3rem;\n        height: 3rem;\n        transition: all 300ms;\n    }\n\n\n    .weekday-display.selected-day {\n\n        transform: scale(101%);\n        color: var(--accent-secondary-color);\n        border: 0.15em solid var(--accent-secondary-color);\n        background-color: white;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
